import {
  IEditManualSubscribedAccess,
  IEditSubscribedAccess,
  IEditSubscriptionBasedSubscribedAccess,
  ISubscribedAccess,
} from '../types/subscribed-access';
import { IPagedResult } from '../types/search';
import { apiService } from './apiService';

class SubscribedAccessService {
  public async getSubscribedAccesses(identityId: string): Promise<ISubscribedAccess[]> {
    return apiService.bffClient
      .get<ISubscribedAccess[]>(`/identities/${identityId}/subscribed-accesses`)
      .then((r) => r.data);
  }

  public getSubscribedAccessHistory(
    identityId: string,
    pageSize = 10,
    pageNumber = 0
  ): Promise<IPagedResult<ISubscribedAccess[]>> {
    return apiService.bffClient
      .get<IPagedResult<ISubscribedAccess[]>>(
        `/identities/${identityId}/subscribed-accesses/history`,
        {
          params: {
            pageSize,
            pageNumber,
          },
        }
      )
      .then((r) => r.data);
  }

  private async putManualSubscribedAccess(
    identityId: string,
    body: IEditManualSubscribedAccess
  ): Promise<number> {
    return apiService.bffClient
      .put(`/identities/${identityId}/subscribed-accesses/support`, body)
      .then((r) => r.status);
  }

  private async putSubscriptionBasedSubscribedAccess(
    identityId: string,
    body: IEditSubscriptionBasedSubscribedAccess
  ): Promise<number> {
    return apiService.bffClient
      .put(
        `/identities/${identityId}/subscribed-accesses/subscription/${body.subscriptionId}/source/${body.source}`,
        [body]
      )
      .then((r) => r.status);
  }

  public isEditSubscriptionBasedSubscribedAccess(
    body: IEditSubscribedAccess
  ): body is IEditSubscriptionBasedSubscribedAccess {
    return (body as IEditSubscriptionBasedSubscribedAccess).subscriptionId !== undefined;
  }

  public async putSubscribedAccess(
    identityId: string,
    body: IEditSubscribedAccess
  ): Promise<number> {
    if (this.isEditSubscriptionBasedSubscribedAccess(body)) {
      return this.putSubscriptionBasedSubscribedAccess(identityId, body);
    } else {
      return this.putManualSubscribedAccess(identityId, body);
    }
  }
}

export const subscribedAccessService = new SubscribedAccessService();
